import request from "@/utils/request.js";
//获取学习资料列表
export const addapply = (data) => {
	return request({
		method: "post",
		url: "api/MeetingSignature/addapply",
		data
	});
};
